exports.install = function(Vue, options) {
  /**
   * 获取是否又该权限
   * @param {*} type 按钮对应的权限的字符串
   */
  Vue.prototype.$getMenuAuthority = function (type) {
    let powerStr =  localStorage.getItem('menuAuthority')
    let power
    let isHas = false
    if(powerStr)
      power = powerStr.split(',')
    power.forEach(element => {
      if(type == element)
        isHas = true
    })
    return isHas
  },
  /**
   * 格式化时间戳
   * @param {*} data 时间戳
   * @param {*} type 日期格式
   */
  Vue.prototype.$formatTime = function(date, type) {
    if(date == '' || date == undefined || date == null) {
      return  ''
    }
    if (type == "all") {
      type = "yyyy-MM-dd hh:mm:ss";
    } else if (type == undefined) {
      type = "yyyy-MM-dd";
    }
    date = new Date(date);
    if (/(y+)/.test(type)) {
      type = type.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds()
    };
    // 遍历这个对象
    for (let k in o) {
      if (new RegExp(`(${k})`).test(type)) {
        let str = o[k] + "";
        type = type.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
        );
      }
    }
    return type;
  };
  
  /**
   * 格式化时间戳
   * @param {*} data 时间戳
   * @param {*} type 日期格式
   */
  Vue.prototype.$formatTimeCN = function(date, type) {
    if(date == '' || date == undefined || date == null) {
      return  ''
    }
    date = new Date(date);
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  };
  Vue.prototype.$formatTimeCN2 = function(date, type) {
    if(date == '' || date == undefined || date == null) {
      return  ''
    }
    date = new Date(date);
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
  };
  /**
   * 树形数据转换
   * @param {*} data
   * @param {*} id
   * @param {*} pid
   */
  Vue.prototype.$treeDataTranslate = function(
    data,
    id = "id",
    pid = "parentId"
  ) {
    var res = [];
    var temp = {};
    for (var i = 0; i < data.length; i++) {
      temp[data[i][id]] = data[i];
    }
    for (var k = 0; k < data.length; k++) {
      if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
        if (!temp[data[k][pid]]["children"]) {
          temp[data[k][pid]]["children"] = [];
        }
        if (!temp[data[k][pid]]["_level"]) {
          temp[data[k][pid]]["_level"] = 1;
        }
        data[k]["_level"] = temp[data[k][pid]]._level + 1;
        temp[data[k][pid]]["children"].push(data[k]);
      } else {
        res.push(data[k]);
      }
    }
    return res;
  };
};



// WEBPACK FOOTER //
// ./src/components/common/base.js